<script lang="ts" setup>
import {SynchroDirection} from "@/domain/type/synchro.type.ts";
import {computed} from "vue";
import {RequestEntity, type SynchroRequestField} from "@/domain/type/synchro.api.type.ts";
import FusionTextArea from "@/components/Fusion/FusionTextArea.vue";

const props = defineProps<{
  request: SynchroRequestField,
  direction?: SynchroDirection,
  entity: RequestEntity
}>()

const text = computed(() => {
  if (SynchroDirection.SRC1_TO_SRC2 === props.direction) {
    return props.request.valueSrc1.replace(/&nbsp;/gi, ' ')
  }
  if (SynchroDirection.SRC2_TO_SRC1 === props.direction) {
    return props.request.valueSrc2.replace(/&nbsp;/gi, ' ')
  }
  return ''
})
const labelTextColor = computed(function () {
  if (props.direction || props.request.isDisallowed) {
    return 'text-white'
  }
  return 'text-grey-darken-2'
})

function getLabel(): string {
  let label = ''
  if (SynchroDirection.SRC1_TO_SRC2 === props.direction) {
    label = props.request.label.split(' <=> ')[0]
  }
  if (SynchroDirection.SRC2_TO_SRC1 === props.direction) {
    label = props.request.label.split(' <=> ')[1]
  }
  return label
}

function getValue(): string {
  if (SynchroDirection.SRC1_TO_SRC2 === props.direction) {
    return props.request.displayValueSrc1 ?? props.request.valueSrc1
  }
  if (SynchroDirection.SRC2_TO_SRC1 === props.direction) {
    return props.request.displayValueSrc2 ?? props.request.valueSrc2
  }
  return ''
}

</script>

<template>
  <div v-if="request.isSynchronized" class="d-flex align-center justify-center h-100">
    <v-icon color="green" icon="mdi-check-circle" size="x-large"/>
  </div>
  <div v-else class="d-flex align-center flex-column h-100">
    <label
      :class="labelTextColor"
      class="pt-1 text-small text-center w-100 text-ellipsis text-no-wrap"
    >
      &nbsp;
    </label>
    <fusion-text-area class="flex-grow-1" :label="getLabel()" :request="request" :synchro-type="entity.requestType" :value="getValue()"/>
  </div>
</template>

<style scoped>

</style>
